import { getField, updateField } from 'vuex-map-fields';
import { vats } from "../../modules/invoices/domain/Invoice"

const state = vats


const getters = {
    getField,
    getTab: state => {
        return [
            {
                code:'iva',
                text:'IVA',
                vats: state.vat,
            },
            {
                code:'igic',
                text:'IGIC',
                vats: state.igic,
            },
            {
                code:'igic2019',
                text:'IGIC 2019',
                vats: state.igic2019,
            },
            {
                code:'igi',
                text:'IGI',
                vats: state.igi,
            },
            {
                code: 'params',
                text: 'Parámetros',
            }
        ]
    },
    getInitialTab: (state, getters) => {
        return getters.getTab;
    },
    formTag: (state) => {
        return state.formTag;
    },
    getInitialTagTab: (state, getters, rootState, rootGetters) => {
        const NAME_LIST =  'tag_list'
        let tab = getters.getTab;
        tab[0].vats.push({label: 'IVA+RE 21%+5.2', vat: 'vat_26_2'});
        tab[0].vats.push({label: 'IVA+RE 10%+1.4%', vat: 'vat_11_4'});
        tab[0].vats.push({label: 'IVA+RE 7.5%+1%', vat: 'vat_75_1'});
        tab[0].vats.push({label: 'IVA+RE 4%+0.5%', vat: 'vat_4_5'});
        tab[0].vats.push({label: 'IVA+RE 2%+0.26%', vat: 'vat_2_026'});
        const formFields = Object.keys(state.formTag);

        function foundLabel(code) {
            let found = false;
            let index = [2, undefined];
            for (var i = 0; !found && i < tab.length; i++) {
                for (var j = 0; tab[i].vats && j < tab[i].vats.length; j++) {
                    let name = tab[i].vats[j].vat;
                    let names = [
                        name,
                        'base_' + name
                    ];
                    if (names.indexOf(code) > -1) {
                        index[0] = i;
                        index[1] = j;
                        found = true;
                        break;
                    } 
                }
            }
            return index;
        }

        function addLabel(label) {
            let index = foundLabel(label.name);
            let i = index[0];
            let j = index[1];
            if (formFields.indexOf(label.name) > -1) {
                state.formTag[label.name] = label;
            } else if ( i === 2 ) {
                if (!tab[i][NAME_LIST]) {
                    tab[i][NAME_LIST] = [];
                }
                tab[i][NAME_LIST].push(label);
            } else {
                if (!tab[i].vats[j][NAME_LIST]) {
                    tab[i].vats[j][NAME_LIST] = {};
                }
                tab[i].vats[j][NAME_LIST][label.name] = label;
            }
        }

        for (var i = 0; i < rootGetters.labels.human.length; i++) {
            addLabel(rootGetters.labels.human[i]);
        }
        return tab;   
    },
};




const mutations = {
    updateField
};


const actions = {};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}